import { render, staticRenderFns } from "./BuildingSocietyIncorporationTaskQueue.vue?vue&type=template&id=3487720c&scoped=true&"
import script from "./BuildingSocietyIncorporationTaskQueue.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyIncorporationTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyIncorporationTaskQueue.vue?vue&type=style&index=0&id=3487720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487720c",
  null
  
)

export default component.exports